/**
 * useRoleDetailForPreview — GET /api/eraf/roles/{id} 상세 (preview simulator 전용).
 *
 * #472: flat predicate 의 requiredPermission 분기 평가를 위해 역할이 보유한
 * permission 코드 집합을 가져온다.
 * role-management 내부를 import 하지 않고 menuApi 의 axios client 를 재사용한다.
 *
 * queryKey: ['menu-management', 'role-detail-for-preview', id]
 * staleTime: 5분
 * enabled: id 가 null/undefined 이 아닌 경우에만 fetch
 */
import { useQuery } from '@tanstack/react-query';
import { menuApi } from '../api/menuApi';

export function useRoleDetailForPreview(id: number | null) {
  return useQuery({
    queryKey: ['menu-management', 'role-detail-for-preview', id],
    queryFn: () => menuApi.getRoleDetail(id!),
    staleTime: 5 * 60 * 1000,
    enabled: id !== null,
  });
}
